import Skeleton from '@discover-ui/skeleton';
import Root, { type RootProps } from './root';

export default function RestaurantCardSubtitleRowSkeleton(props: Omit<RootProps, 'children'>) {
  return (
    <Root {...props}>
      <span className="flex max-w-full flex-row items-center gap-1.5">
        <Skeleton as="span" className="truncate">Loading cuisines...</Skeleton>
        <span aria-hidden="true">&middot;</span>
        <Skeleton as="span" className="truncate">Loading location...</Skeleton>
      </span>
    </Root>
  );
}
